import React from 'react';
import icon from '../images/icon-4.svg';
import img from '../images/logo/leads.png'
import img1 from '../images/logo/trust.png'
import img2 from '../images/logo/sales.png'
import img3 from '../images/logo/growth.png'
import img4 from '../images/logo/data-strategy.png'

export const Benefits = () => {
    const data = [
        { name: "Leads on Autopilot", icon: img, data: "Say goodbye to chasing clients. Our system brings in <span class='g-green'>high-quality leads</span> effortlessly, so you can focus on what matters—closing deals." },
        { name: "Authority & Brand Trust", icon: img1, data: "Become the go-to expert in your niche with content that <span class='g-green'>positions you as a thought leader</span> and builds unshakable credibility." },
        { name: "Sales-Driven Strategy", icon: img2, data: "We don’t just create content—we design a roadmap that turns attention into action, nurturing your audience from <span class='g-green'>curiosity to conversion.</span>" },
        { name: "Scalable Growth Engine", icon: img3, data: "Whether you're just starting or scaling, our content strategies evolve with you, ensuring consistent <span class='g-green'>visibility and business growth.</span>" },
        { name: "Data-Driven Strategy", icon: img4, data: "No guesswork. Every decision is powered by analytics, helping us fine-tune your content for maximum <span class='g-green'>engagement, reach, and ROI.</span>" },
    ]

    return (
        <div className='benefits'>
            <div className="icon-5">
                <img alt="Process Icon" src={icon} />
            </div>
            <div className="container">
                <div className="content">
                    <div className="heading">
                        <div className="content">
                            <div className="icon-4">
                                <img alt="Process Icon" src={icon} />
                            </div>
                            <h3>What do you <span className='g-green'>get?</span></h3>
                            <span style={{ background: "linear-gradient(90deg, var(--light-green) 10%, var(--dark-green) 90%)" }}>Benefits</span>
                        </div>
                    </div>
                    <div className="content-slides">
                        {data.map((keys, ind) => {
                            return <div
                                key={ind}
                                className={"box wow animate__animated animate__fadeInUp"}
                                data-wow-duration={"1.2s"}
                                data-wow-delay={"0.1s"}
                            >
                                <div className="icon">
                                    <img src={keys.icon} alt="" />
                                </div>
                                <h4>{keys.name}</h4>
                                <p dangerouslySetInnerHTML={{ __html: keys.data }}></p>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div >
    )
}
